import {LeftColumn, RightColumn} from "../Components/Column";
import Page from "./Page";

function ExhibitsPage() {
    return (
        <Page title="Exhibits">
            <LeftColumn>
                <p className="portfolio-subtitle">PAST:</p>

                <a href="/images/2024-print-event.jpg" target="_blank" rel="noreferrer">
                    <img src="/images/2024-print-event_thumb.webp" alt="printmaking event" style={{ maxWidth: '100%', height: 'auto' }}/>
                </a>

                <p>
                    September 19&#45;October 31, 2024: "DEPORTEES: A Tribute," Emerson Brook Forest Center, 57
                    Emerson Brook Drive, Gilsum, NH. Opening reception, September 19, 4-6 pm. Works by sculptor
                    Susan O'Hara and printmaker Erika Radich. For information or access, call Valerie
                    Piedmont:
                    {' '}
                    <span className="mobile-phone-number">603-209-7272</span>.
                </p>

                <p>
                    August 16&#45;September 16, 2024:
                    {' '}
                    <a
                        href="https://wharepuke.nz/art-at-wharepuke/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Wharepuke Print Show</a>
                    , Wharepuke Gallery, 190 Kerikeri Rd, Wharepuke, New Zealand.
                </p>

                <p>
                    October 10&#45;November 2, 2024:
                    {' '}
                    <a
                        href="https://www.apearts.org/"
                        className="news-link"
                        target="_blank" rel="noreferrer">APE Gallery</a>
                    , 126 Main St, Northampton, MA, "Formerly Known as Prints," Prints by Zeamays Printmaking
                    Studio artists, Opening reception, October 19, 2-5 pm.
                </p>

                <p className="portfolio-title-subtitle-2">Solo or Two Person Exhibits:</p>

                <p>
                    July 8&#45;August 27, 2023:
                    {' '}
                    <a
                        href="https://salmonfallsgallery.com/exhibits--events.html"
                        className="news-link"
                        target="_blank" rel="noreferrer">"Two Conversations,"</a>
                    {' '}
                    Salmon Falls Gallery, 1 Ashfield Street, Shelburne Falls, MA, Opening reception: July 8,
                    2-4pm, Works by Sharon Myers and Erika Radich
                </p>

                <p>
                    July 15&#45;August 27, 2023:
                    {' '}
                    <a
                        href="https://mitchellgiddingsfinearts.com/current-exhibits/"
                        className="news-link"
                        target="_blank" rel="noreferrer">INNER LANDSCAPES: Three Views</a>
                    , Mitchell Giddings Fine Arts, 183 Main Street, Brattleboro, VT. Works by Maggie Cahoon,
                    Jessie Pollock, and Erika Radich, Opening reception, July 15, 5-7, Artist Forum, August 6,
                    5-7.
                </p>

                <p>
                    February&#45;April, 2023:
                    {' '}
                    <a
                        href="https://hsccnh.org/two-conversations/"
                        className="news-link"
                        target="_blank" rel="noreferrer">"Two Conversations,"</a>
                    {' '}
                    Historical Society of Cheshire County, Main Street, Keene, NH, Works by Sharon Myers and
                    Erika Radich
                </p>

                <p>
                    October 3&#45;November 1, 2022: "
                    <a
                        href="https://www.zeamaysprintmaking.com/exhibitions/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Green to the Extreme</a>
                    ," Zea Mays Printmaking Group Show: A.P.E. Gallery, Northampton, MA.
                </p>

                <p>
                    December 5&#45;January 31, 2021, Solo Exhibit: "Deportees: A Tribute,"
                    {' '}
                    <a
                        href="https://mitchellgiddingsfinearts.com/index.php/artists.html"
                        className="news-link"
                        target="_blank" rel="noreferrer">Mitchell-Giddings Fine Arts</a>
                    , Brattleboro, VT.
                </p>

                <p>
                    October 8&#45;29, 2019: "
                    <b>
                        <a
                            href="https://fac.umass.edu/Online/default.asp?BOparam::WScontent::loadArticle::permalink=AugustaSavage&BOparam::WScontent::loadArticle::context_id=#link&menu_id=32333C27-D358-4995-9AC3-4640BFADA3D8&sToken=1%2C4cf6488b%2C5cbdc3bb%2CD8298DD3-1EE2-4072-9800-1E72AE756C8E%2Cq3zxo7QiirpuPJe8ZxVm6jS8X7A%3D"
                            className="news-link"
                            target="_blank" rel="noreferrer">Games of Chance</a>
                    </b>
                    ," Augusta Savage Gallery, University of Massachusetts, Amherst, MA, Two person
                    exhibit&hellip;showing works by Rocio Olguin and Erika Radich
                </p>

                <p>
                    May 7&#45;31, 2019: "
                    <b>
                        <a
                            href="https://www.zeamaysprintmaking.com/exhibitions/"
                            className="news-link"
                            target="_blank" rel="noreferrer">Self-Reflective</a>
                    </b>
                    ," Sanford Gallery, Zea Mays Printmaking Studio, Florence, MA
                </p>

                <p>
                    October 24&#45;November 10, 2016:
                    {' '}
                    <b>"Lotus in the Mud,"</b>
                    {' '}
                    Solo exhibit at
                    {' '}
                    <a
                        href="https://fac.umass.edu/Online/default.asp?BOparam::WScontent::loadArticle::permalink=AugustaSavage&BOparam::WScontent::loadArticle::context_id=&sessionlanguage="
                        className="news-link"
                        target="_blank" rel="noreferrer">Augusta Savage Gallery</a>
                    , University of Massachusetts, Amherst, MA
                </p>

                <p>
                    November 6&#45;28th, 2015:
                    {' '}
                    <b>"Order/Disorder,"</b>
                    {' '}
                    Solo exhibit at Sharon Arts Center, Peterborough, NH
                </p>

                <p>
                    December 2014:
                    {' '}
                    <b>Art in the Loo,</b>
                    {' '}
                    <a
                        href="https://zeamaysprintmaking.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Zea Mays Printmaking Studio</a>
                    , 320 Riverside Drive, Florence, MA
                </p>

                <p>
                    September 21, 27, 28, October 4,5 Sculpture by Linda Hoffman and and
                    {' '}
                    <b>Prints by Erika Radich,</b>
                    {' '}
                    <a
                        href="https://oldfrogpondfarm.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Old Frog Pond Farm Studio</a>.
                </p>

                <p>
                    July 31&#45;August 24, 2014
                    {' '}
                    <b>Nature as Medicine, Nature as Companion,</b>
                    {' '}
                    <a
                        href="https://letterpressasapublicartproject.wordpress.com/current-and-upcoming-exhibits/"
                        className="news-link"
                        target="_blank" rel="noreferrer">PRESS: Letterpress as a Public Art Project</a>
                    , 49 Main Street, North Adams, MA
                </p>

                <p>November 2012 Prints on exhibit at American Traders, West Brattleboro, VT</p>

                <p>
                    October 4&#45;Nov 3, 2012:
                    {' '}
                    <a
                        href="https://sites.keene.edu/newsline/2012/09/26/printmaking-invitational-2012-at-the-carroll-house-gallery/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Printmaking Invitational 2012</a>
                    , Carroll House Gallery, Keene State College, 238 Main St, Keene, NH
                </p>

                <p>
                    January 6&#45;February 10, 2012: Carolyn Webb and Erika Radich at
                    {' '}
                    <a
                        href="https://zeamaysprintmaking.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Zea Mays Printmaking Gallery</a>
                    , Arts and Industries Building, Florence, MA
                </p>

                <p>
                    September 1&#8211;November 30, 2009
                    {' '}
                    <a
                        href="https://www.thecolonial.org/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Colonial Theatre (Colonial Corner)</a>
                </p>

                <p>
                    July 18&#8211;August 8, 2009
                    {' '}
                    <a
                        href="https://www.thestarvingartistcollective.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">The Starving Artist</a>
                    {' '}
                    Solo Exhibit
                </p>

                <p>2003 <b>New Work,</b> Redfern Arts Center at Brickyard Pond, KSC, Keene, NH</p>

                <div className="portfolio-title-subtitle-2">Group Exhibits:</div>

                <p>
                    April-through summer 2020: "The Force of Nature,"
                    {' '}
                    <a
                        href="https://www.zeamaysprintmaking.com/editions-artists-book-fair-2019/"
                        className="news-link"
                        target="_blank" rel="noreferrer">William Ris Gallery, Jamesport, NY</a>.
                </p>

                <p>
                    November 7&#45;28, 2019: "Sychronicity,"
                    {' '}
                    <a
                        href="https://www.zeamaysprintmaking.com/editions-artists-book-fair-2019/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Easthampton City Arts Exhibition</a>
                    , Zea Mays Printmaking Group Exhibit, 43 Main Street, Easthampton, MA. Opening reception:
                    Saturday, November 9, 5-8pm.
                </p>

                <table style={{marginBottom: "20px"}}>
                    <tbody>
                    <tr>
                        <td style={{width: "150px"}}>
                            <a
                                href="https://10times.com/eab-fair"
                                className="news-link"
                                target="_blank" rel="noreferrer">
                                <img
                                    src="/images/eab-fair.gif"
                                    style={{
                                        maxWidth: "200px",
                                        width: "100%",
                                        height: "auto"
                                    }}
                                    alt="eab fair"/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>

                <p>
                    June 21&#45;September 29, 2019: Keene State College, Keene, NH: Thorne-Sagendorph Art
                    Gallery
                    {' '}
                    <a
                        href="https://www.keene.edu/tsag/"
                        className="news-link"
                        style={{fontWeight: "bold"}}
                        target="_blank" rel="noreferrer">2019 Biennial Regional Jurors' Choice Exhibition</a>.
                    Artist Opening Reception: Friday, June 21, 5-7. Closing Reception: Sunday, September 29,
                    3-5. Winner of "Peoples' Choice Award"
                </p>

                <p>
                    August 16&#45;September 30, 2018,
                    {' '}
                    <a
                        href="https://mitchellgiddingsfinearts.com/index.php/exhibits.html"
                        className="news-link"
                        style={{fontWeight: "bold"}}
                        target="_blank" rel="noreferrer">Voices: A Selection of Zea Mays Printmakers</a>
                    , Opening: Thursday, August 16, 5-7, Artist Reception: Saturday, August 18, 5-7, Artist
                    Talk: Saturday, August 25, 5pm. Mitchell-Giddings Fine Art, Brattleboro, VT
                </p>

                <p>
                    October 5&#45;November 4, 2018, “
                    <a
                        href="https://www.northamptonartscouncil.org/2018/09/the-space-between-two-zea-mays.html"
                        className="news-link"
                        style={{fontWeight: "bold"}}
                        target="_blank" rel="noreferrer">The Space Between Two</a>
                    ” Zea Mays Printmaking Biennial, Reception October 12, 5-8, A.P.E Gallery, 126 Main
                    Street, Northampton, MA.
                </p>

                <p>
                    June 28&#45;August 12, 2018, Torin Porter:
                    {' '}
                    <a
                        href="https://mitchellgiddingsfinearts.com/index.php/exhibits.html"
                        className="news-link"
                        target="_blank" rel="noreferrer">Day Dreams, Opening</a>
                    {' '}
                    Thursday, June 28, 5-7pm, Artist Reception: Saturday, June 30, 5-7. (I have eight
                    collages in this exhibit.) Mitchell-Giddings Fine Art, Brattleboro, VT
                </p>

                <p>
                    March 29&#45;May 6, 2018, PROCESS!,
                    {' '}
                    <a href="https://www.concordart.org" className="news-link" target="_blank" rel="noreferrer">
                        Concord Center for the Visual Arts
                    </a>
                    , 37 Lexington Road, Concord, MA. Opening reception: March 29, 6-8pm.
                </p>

                <p>
                    March 26&#45;April 30,
                    {' '}
                    <b>HOME</b>
                    , Group Show at
                    {' '}
                    <a
                        href="https://fac.umass.edu/Online/default.asp?BOparam::WScontent::loadArticle::permalink=AugustaSavage&BOparam::WScontent::loadArticle::context_id=&sessionlanguage="
                        className="news-link"
                        target="_blank" rel="noreferrer">Augusta Savage Gallery</a>
                    , University of Massachusetts, Amherst, MA
                </p>

                <p>
                    January 11&#45;March 18,
                    {' '}
                    <a
                        href="https://www.mitchellgiddingsfinearts.com/index.php/events.html"
                        className="news-link"
                        target="_blank" rel="noreferrer"><i>Winter Group 2018</i></a>
                    , Mitchell Giddings Fine Arts, 183 Main Street, Brattleboro, VT. Opening reception:
                    Thursday, January 11, 5-7. Artist Talk: Saturday, February 10, 5pm.
                </p>

                <p>
                    December 1&#45;15, 2017, Group Exhibit at Historic Harrisville, Granite Mill, 69 Main St.,
                    Harrisville, NH. Artist Reception: December 1, 5-8.
                </p>

                <p>
                    February 6&#45;March 10, 2017: Printmakers of Zea Mays,
                    {' '}
                    <a
                        href="https://web.ccis.edu/departments/visualartsandmusic/greghardwickgallery.aspx"
                        className="news-link"
                        target="_blank" rel="noreferrer">The Greg Hardwick Gallery</a>
                    , Columbia College, Columbia, MO
                </p>

                <p>
                    February 1&#45;March 4, 2017:
                    {' '}
                    <a
                        href="https://www.meca.edu/events/category/ica/"
                        className="news-link"
                        target="_blank" rel="noreferrer">The Unity of Opposites</a>
                    , Institute of Contemporary Art, Portland, ME
                </p>

                <p>
                    September 3&#45;October 10:
                    {' '}
                    <a
                        href="https://oldfrogpondfarm.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Old Frog Pond Farm &amp; Studio's</a>
                    {' '}
                    Tenth Annual Outdoor Sculpture Exhibit, 38 Eldridge Road, Harvard, MA
                </p>
            </LeftColumn>

            <RightColumn>
                <div className="portfolio-title-subtitle-2">Group Exhibits (continued):</div>

                <p>
                    October 5-30, 2016:
                    {' '}
                    <a
                        href="https://www.meca.edu/events/category/ica/"
                        className="news-link"
                        target="_blank" rel="noreferrer">The Unity of Opposites</a>
                    , APE Gallery, Northampton, MA
                </p>

                <p>
                    October 2, 2016: 10- 5,
                    {' '}
                    <a
                        href="https://northamptonprintandbookfair.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Northampton Print and Book Fair and Big Ink</a>
                    , Downtown Northampton, MA
                </p>

                <p>
                    August 6-27, 2016: "State of Nature," Group Exhibit at
                    {' '}
                    <a
                        href="https://www.arundelfarmgallery.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Arundel Farm Gallery</a>
                    , Arundel, ME
                </p>

                <p>July 21, 2016: Recipient of Ewing Arts Award. Award Ceremony.</p>

                <p>
                    July 7-August 27, 2016:
                    {' '}
                    <a
                        href="https://printworkshopcentral.com/zea-mays-printmaking-florence-ma-usa/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Hot off the Press: Zea Mays Printmaking</a>
                    , Hope and Feathers Gallery, Amherst, MA
                </p>

                <p>
                    July 1-August 18, 2016:
                    {' '}
                    <a
                        href="https://printworkshopcentral.com/zea-mays-printmaking-florence-ma-usa/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Working Green: Zea Mays Printmaking</a>
                    , Manhattan Graphics Center, New York.
                </p>

                <p>
                    <a href="https://www.keeneartwalk.com" className="news-link" target="_blank" rel="noreferrer">Artwalk</a>
                    : June 3 - June 12th, 2016. Downtown Keene, NH
                </p>

                <p>
                    September 26th : Print Fair North 2015, 10-5pm, Zea Mays Printmaking Studio, 320 Riverside
                    Drive, Florence, MA
                </p>

                <p>
                    November 1-December 29, 2015:
                    {' '}
                    <a
                        href="https://www.salmonfallsgallery.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Salmon Falls Artisans Showroom</a>
                    , 1 Ashfield St. #9, Shelburne Falls, MA
                </p>

                <p>
                    August 30-Oct 5, 2015: Plate to Paper,
                    {' '}
                    <a
                        href="https://chasesgarage.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Chase's Garage</a>
                    , York, ME
                </p>

                <p>
                    Aug 29, 30, 2014:
                    {' '}
                    <a
                        href="https://monadnockareaartists.org/News/?attachment_id=1343"
                        className="news-link"
                        target="_blank" rel="noreferrer">Monadnock Area Artist Association's</a>
                    {' '}
                    Art in the Park, Keene, NH. Second Prize.
                </p>

                <p>
                    July 31-August 24, 2014
                    {' '}
                    <a
                        href="https://letterpressasapublicartproject.wordpress.com/current-and-upcoming-exhibits/"
                        className="news-link"
                        target="_blank" rel="noreferrer">PRESS: Letterpress as a Public Art Project</a>
                    , 49 Main Street, North Adams, MA (artist reception: July 31, 5-8pm)
                </p>

                <p>
                    September 1, 2013
                    {' '}
                    <a href="https://www.keeneartwalk.com" className="news-link" target="_blank" rel="noreferrer">Art in the Park</a>
                    , Keene, NH. 3rd Prize
                </p>

                <p>
                    February 23-April 6, 2013: Monotype Guild of New England's 3rd National Exhibition at the
                    {' '}
                    <a
                        href="https://www.gordon.edu/finearts/barrington"
                        className="news-link"
                        target="_blank" rel="noreferrer">Barrington Center for the Arts</a>
                    , Gordon College, Wenham, Massachusetts. Opening reception at 3:30-5:30, March 2, 2013.
                </p>

                <p>
                    January 25 to March 7, 2013: "Honorable Mention", Biennial Regional Juror's Choice
                    Competition at the Keene State College
                    {' '}
                    <a href="https://www.keene.edu/tsag/" className="news-link" target="_blank" rel="noreferrer">Thorne-Sagendorph
                        Gallery</a>
                    , Keene, NH.
                </p>

                <p>
                    November 10-11, 2012:
                    {' '}
                    <a
                        href="https://printworkshopcentral.com/zea-mays-printmaking-florence-ma-usa/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Print Fair North</a>
                    , Zea Mays Printmaking Studio, 320 Riverside Dr., Florence, MA
                </p>

                <p>
                    September 1-2, 2012
                    {' '}
                    <a href="https://www.keeneartwalk.com" className="news-link" target="_blank" rel="noreferrer">Art in the Park</a>
                    , Keene, NH. First Prize
                </p>

                <p>
                    March 2012 Print Counter-Print,
                    {' '}
                    <a
                        href="https://www.rosecontemporary.com/print-counter-print.php"
                        className="news-link"
                        target="_blank" rel="noreferrer">Rose Contemporary Gallery</a>
                    , Portland, ME
                </p>

                <p>
                    April-October 2012 Conscious Impressions,
                    {' '}
                    <a
                        href="https://springfieldmuseums.org/about/museum-of-fine-arts/"
                        className="news-link"
                        target="_blank" rel="noreferrer">D'Amour Museum</a>
                    , Springfield, MA
                </p>

                <p>
                    January 26-February 23, 2012:
                    {' '}
                    <a href="https://www.nhia.edu/presentations/" className="news-link" target="_blank" rel="noreferrer">
                        Prominent Printmakers, New Hampshire Institute of Art
                    </a>
                    , Manchester, NH, French Building.
                </p>

                <p>
                    November 2011:
                    {' '}
                    <a
                        href="https://printworkshopcentral.com/zea-mays-printmaking-florence-ma-usa/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Print Fair North</a>
                    , Zea Mays Printmaking Studio, Florence, MA
                </p>

                <p>
                    Fall 2011:
                    {' '}
                    <a
                        href="https://www.aber.ac.uk/en/art/gallery-museum/"
                        className="news-link"
                        target="_blank" rel="noreferrer">School of Art Gallery and Museum at Aberystwyth University</a>
                    , Aberystwyth, Wales, UK
                </p>

                <p>
                    September 2011:
                    {' '}
                    <a href="https://monadnockartists.org/pages/ArtinthePark.html" className="news-link" target="_blank" rel="noreferrer">
                        First Prize, Art in the Park
                    </a>
                    {' '}
                    (Monadnock Area Arts Association)
                </p>

                <p>
                    September 2011:
                    {' '}
                    <a href="https://www.a4printmakers.com/" className="news-link" target="_blank" rel="noreferrer">
                        The 2nd Open International Contemporary Print Competition
                    </a>
                    {' '}
                    in South West Cornwall, UK. The Poly Arts Centre, Falmouth, Cornwall
                </p>

                <p>
                    August 3-27, 2011:
                    {' '}
                    <a
                        href="https://www.bromfieldgallery.com/exhibitions.html"
                        className="news-link"
                        target="_blank" rel="noreferrer">Printed Green: Zea Mays Printmaking</a>
                    , Bromfield Gallery, Boston, MA
                </p>

                <p>
                    May 2011:
                    {' '}
                    <a href="https://www.lorgprintmakers.com/" className="news-link" target="_blank" rel="noreferrer">
                        Lorg Fine Art Printmakers
                    </a>
                    , Ltd Workshop and Gallery, Galway, Ireland
                </p>

                <p>
                    February 19-March 26, 2011:
                    {' '}
                    <a href="https://www.zullogallery.org/" className="news-link" target="_blank" rel="noreferrer">Expressions</a>
                    , Zullo Gallery, Medfield, MA
                </p>

                <p>
                    February 4-March 10, 2011:
                    {' '}
                    <a href="https://www.keene.edu/tsag/exhibits.cfm" className="news-link" target="_blank" rel="noreferrer">
                        Biennial Regional Juror's Choice
                    </a>
                    , Thorne-Sagendorph Gallery, Keene State College, Keene, NH
                </p>

                <p>
                    December 4-12, 2010:
                    {' '}
                    <a href="https://www.moco.org/" className="news-link" target="_blank" rel="noreferrer">
                        MoCo Masters: Faculty &amp; Community Invitational Art Show
                    </a>
                </p>

                <p>
                    November 2010: Print Fair North,
                    {' '}
                    <a href="https://www.zeamaysprintmaking.com/" className="news-link" target="_blank" rel="noreferrer">
                        Zea Mays Printmaking Studio
                    </a>
                    , Florence, MA
                </p>

                <p>
                    September 2010
                    {' '}
                    <a
                        href="https://www.keeneartassoc.org/pages/ArtinthePark.html"
                        className="news-link"
                        target="_blank" rel="noreferrer">Art in the Park</a>
                    , (Monadnock Area Arts Association) Keene NH
                </p>

                <p>
                    July 2010 Momenta IV.
                    {' '}
                    <a
                        href="https://www.tworiversprintmaking.com/"
                        className="news-link"
                        target="_blank" rel="noreferrer">Two Rivers Printmaking Studio</a>
                    , White River Junction, VT
                </p>

                <p>
                    May-June 2010: Half a World Away-Sustainable Printmaking Exhibit: Wharepuke Print Studio,
                    Keri Keri, NZ and A.P.E. Windows Gallery, Northampton, MA
                </p>

                <p>
                    June 5-14, 2010
                    {' '}
                    <a href="https://www.keeneartwalk.com" className="news-link" target="_blank" rel="noreferrer">Keene Artwalk</a>
                </p>

                <p>
                    November 14, 15, 2009 Print Fair North:
                    {' '}
                    <a href="https://www.zeamaysprintmaking.com/" className="news-link" target="_blank" rel="noreferrer">
                        Zea Mays Printmaking Studio
                    </a>
                    , Florence, MA
                </p>

                <p>
                    June 5-14, 2009
                    {' '}
                    <a href="https://www.keeneartwalk.com" className="news-link" target="_blank" rel="noreferrer">Keene Artwalk</a>
                </p>

                <p>2009 New Prints Curated by Polly Apfelbaum, International Print Center New York</p>

                <p>2009 Biennial Regional Juried Exhibit Thorne Sagendorph Gallery, KSC, Keene, NH</p>

                <p>2009 Touching Space (flow) Group Show, Zea Mays Printmaking, Florence, MA</p>

                <p>2008 New Prints, Redmond Bennett Gallery Group Show, Dublin, NH</p>

                <p>2008 black, white, and color, Redmond Bennett Gallery Group Show, Dublin, NH</p>

                <p>2008 New Work, Season III, Redmond Bennett Gallery Group Show, Dublin, NH</p>

                <p>2008 VISUAL FIELDS, Three person exhibit, Zea Mays Printmaking, Florence, NH</p>

                <p>2008 "3", Three person exhibit, MurphyArts, Keene, NH</p>

                <p>2007 From Palette to Palate, Sharon Arts Center Juried Exhibit, Peterborough, NH</p>

                <p>2007 Biennial Regional Juried Exhibit, Thorne Sagendorph Gallery, KSC, Keene, NH</p>

                <p>1994 Sharon Arts Center Regional Juried Exhibit, Peterborough, NH</p>

                <p>1994 Two Person Exhibit, Shaw Gallery, Keene, NH</p>

                <p>1993 Regional Juried Exhibit, AVA Gallery, Lebanon, NH</p>

                <p>1992 Two Person Exhibit, Shaw Gallery, Keene, NH</p>

                <p>1994, 1993, 1992: Grand Monadnock Arts Council Artwalk Participant, Keene, NH</p>
            </RightColumn>
        </Page>
    );
}

export default ExhibitsPage;

